//import { login, logout, getInfo } from '@/api/user'
import { getCookie, setCookie, delCookie } from '@/ask/cookiejs'
// import { getCookie, setCookie, removeCookie } from '@/utils/auth'
import { resetRouter } from '@/router'
import { post } from '@/ask/axios'
import Vue from "vue"
///BasicsSupplier/api/SupplierLogin/SupplierLogin

const getDefaultState = () => {
  return {
    token: getCookie("X-JWT-SUPTOKEN"),
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token, IMToken) => {
    setCookie("X-JWT-SUPTOKEN", token)
    setCookie("IMToken", IMToken)
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { userNo, password } = userInfo
    return new Promise((resolve, reject) => {
      let url = Vue.prototype.$api04 + "/BasicsSupplier/api/SupplierLogin/SupplierLogin"
      // login({ logName: logName.trim(), pwd: pwd }).then(response => {
      post(url, { logName: userNo.trim(), pwd: password }).then(response => {
        if (response.IsOK) {
          const { Results } = response
          commit('SET_TOKEN', Results.Token, Results.IMToken)
          setCookie("X-JWT-SUPTOKEN", Results.Token)
          setCookie("IMToken", Results.IMToken);
          setCookie("userInfo", JSON.stringify(Results));
          localStorage.setItem('userInfo', JSON.stringify(Results))
          resolve()
        } else {
          //resolve(response.Message)
          reject(response.Message)
        }

      }).catch(error => {
        reject(error)
      })
    })
  },
  //供应商微信绑定登录
  supplierLogin(comtext, params) {
    return new Promise((resolve, reject) => {
      let url = Vue.prototype.$api04 + "/BasicsSupplier/api/SupplierLogin/SupplierLogin"
      post(url, params).then(({ Results, Message, IsOK }) => {
        if (IsOK) {
          //comtext.commit("SET_TOKEN", { JWT: Results.Token, IM: Results.IMToken })

          // comtext.commit('user/DIALOG_VISIBLE', false)
          // setCookie("JWT-TOKEN", Results.Token)
          setCookie("X-JWT-SUPTOKEN", Results.Token)
          setCookie("IM-TOKENSUP", Results.IMToken)
          setCookie("SuplierLoginName", Results.LoginName)
          //setCookie("customerID", Results.CustomerId)
        } else {
          // 登录结果埋点
          // tarckDot(this, Results, Message)
        }
        resolve({ Results, Message, IsOK })
      })
    })
  },
  getVerCode(comtext, info) {
    // console.log("🚀 ~ comtext", comtext)
    return new Promise((resolve, reject) => {
      const url = Vue.prototype.$apiIse + "/api/EbaySupplier/MobileCode/SendMobileVerifyCodeEditPhone"
      post(url, info).then(function (res) {
        if (res.IsOK) {
          resolve(res)
        }
        else {
          Vue.prototype.$notify({
            title: res.Message,
            type: "error",
          })
        }
        //定制埋点--手机验证码是否成功
        // sensors.track("get_code_result", {
        //   service_type: "注册",
        //   get_type: "手机号",
        //   is_success: res.Results,
        //   fail_reason: res.Message,
        //   return_duration: "",
        // })
      })
    })
  },
  // get user info
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response

  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }

  //       const { name, avatar } = data

  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // user logout
  // logout({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     logout(state.token).then(() => {
  //       removeCookie("X-JWT-SUPTOKEN") // must remove  token  first
  //       resetRouter()
  //       commit('RESET_STATE')
  //       resolve()
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      delCookie("X-JWT-SUPTOKEN") // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

